import { render, staticRenderFns } from "./agv-order-article.vue?vue&type=template&id=d82956c2&scoped=true&lang=pug&"
import script from "./agv-order-article.vue?vue&type=script&lang=js&"
export * from "./agv-order-article.vue?vue&type=script&lang=js&"
import style0 from "./agv-order-article.vue?vue&type=style&index=0&id=d82956c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82956c2",
  null
  
)

export default component.exports